import { axiosInstance } from "../App";

// Servicios públicos para la validación de recetas digitales
// Estos servicios no requieren autenticación y están pensados para ser usados
// desde la vista pública DigitalRPQRView

export async function getDataDecriptPublic(professional: string, patient: string, digitalRPuuid: string) {
    return axiosInstance.post('/api/public/digitalrpservicecontroller/getDataDecript', {
        professional: professional,
        patient: patient,
        digitalRPuuid: digitalRPuuid
    }).then(res => res.data).catch(err => err);
}

export function getDigitalRPMarkRecordPublic(rpUuid: string) {
    return axiosInstance.get('/api/public/digitalrpservicecontroller/getDigitalRPMarkRecord', {
        params: {
            rpUUID: rpUuid
        }
    }).then(res => res).catch(err => err);
}

export function getPdfDigitalRpByUUIDPublic(rpUUID: string) {
    return axiosInstance.get('/api/public/digitalrpservicecontroller/findDigitalRPPDFByUUID', {
        params: {
            rpUUID: rpUUID
        },
        responseType: 'blob',
    }).then((res: any) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'receta.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return true;
    }).catch(err => {
        return false;
    });
}

export async function setDigitalRpAsUsedPublic(digitalrp: string, pharmacy: string) {
    let ip = "";
    let coordenadas: any = {};
    
    const onLocationAllowed = ({ coords, timestamp }: any) => {
        coordenadas = coords;
    }

    const onLocationNotAllowed = () => {
        // No hacer nada si no se permite la ubicación
    }

    navigator.geolocation?.getCurrentPosition(onLocationAllowed, onLocationNotAllowed);
    
    let ipResponse = await getClientIpPublic();
    if (ipResponse.status == 200)
        ip = ipResponse.data;

    let rpMarkedResponse = await setDigitalRpAsMarkedPublic(
        ip, 
        coordenadas.latitude ? coordenadas.latitude : null, 
        coordenadas.longitude ? coordenadas.longitude : null, 
        digitalrp, 
        pharmacy
    );

    return rpMarkedResponse;
}

export async function setDigitalRpAsMarkedPublic(ip: any, latitude: any, longitude: any, digitalrp: any, pharmacy: any) {
    let response = await axiosInstance.post('/api/public/digitalrpservicecontroller/setDigitalRPAsUsed', {
        ip: ip,
        latitude: latitude,
        longitude: longitude,
        browser: navigator.userAgent,
        digitalRpUUID: digitalrp,
        identification: pharmacy
    }).then(res => res.data).catch(err => err);
    return response;
}

export async function getClientIpPublic() {
    let response = await axiosInstance.get('/api/public/digitalrpservicecontroller/getIp').then(res => res).catch(err => err);
    return response;
}

export function findDigitalRPPDFByCodeBarPublic(codeBar: string) {
    return axiosInstance.get('/api/public/digitalrpservicecontroller/findDigitalRPPDFByCodeBar', {
        params: {
            codeBar: codeBar
        }
    }).then(res => res.data).catch(err => err);
}
